export const selectParametersFilters = (state) => state.parameters.filters;
export const selectParametersMode = (state) => state.parameters.mode;
export const selectParametersActiveMode = (state) => state.parameters.activeMode;
export const selectParametersAttributefilters = (state) => state.parameters.attributeFilters;
export const selectParametersNotRecommendedFnd = (state) => state.parameters.not_recommended_fnd;



